import {NgModule} from '@angular/core';
import {LocalStorageService} from './service/local-storage.service';
import {UserPreferencesService} from './service/user-preferences.service';
import {BaseComponent} from './components/base.component';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {MDBBootstrapModulesPro} from 'ng-uikit-pro-standard';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AuthInterceptor} from '../../http/auth.interceptor';
import {LoggerService} from './service/logger.service';
import {LocalizationService} from './service/localization.service';
import {AuthorizationService} from './service/authorization.service';
import {TitleComponent} from './components/title/title.component';
import {ErrorAlertComponent} from './components/error-alert/error-alert.component';
import {TitleDirective} from './directives/title.directive';
import {BgDirective} from './directives/bg.directive';
import {TextColorDirective} from './directives/text-color.directive';
import {TokenService} from './service/token.service';
import {DashboardTileComponent} from './components/dashboard-tile/dashboard-tile.component';
import {ErrorLogService} from './service/error-log.service';
import {DeviceService} from "./service/device.service";
import {TwoFactorService} from "./service/two-factor.service";
import {RedirectService} from "./service/redirect.service";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    MDBBootstrapModulesPro.forRoot(),
  ],
  declarations: [
    BaseComponent,
    TitleComponent,
    ErrorAlertComponent,
    TitleDirective,
    BgDirective,
    TextColorDirective,
    DashboardTileComponent,
  ],
  providers: [
   LocalizationService,
   AuthorizationService,
   LoggerService,
   LocalStorageService,
   UserPreferencesService,
   TokenService,
   ErrorLogService,
   DeviceService,
   TwoFactorService,
   RedirectService,
   { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  exports: [
    BaseComponent,
    TitleComponent,
    ErrorAlertComponent,
    TitleDirective,
    BgDirective,
    TextColorDirective,
    DashboardTileComponent
  ]
})
export class SharedModule {}
